import FooterView from "@/src/screen/footer/FooterView"
import HeaderScreen from "@/src/screen/header/HeaderScreen"
import React from "react"

const Layout = ({ children, footer }: { children: React.ReactNode, footer?: boolean }) => {
    return (
        <>
            <HeaderScreen />
            <main className="container mx-auto">
                {children}
            </main>
            {
                footer ? null :
                    <FooterView />
            }
        </>
    )
}

export default Layout